export const BOUNDARIES_SOURCE_ID = "boundaries";
export const BOUNDARIES_OUTSIDE_AREA_SOURCE_ID = "boundaries-outside-area";

export const BOUNDARIES_OUTLINE_LAYER_ID = "boundaries-outline";
export const OUTSIDE_AREA_LAYER_ID = "background-mask";
export const BOUNDARIES_ADDITIONAL_OUTLINE_LAYER_ID =
    "boundaries-additional-outline";
export const BOUNDARIES_FILL_LAYER_ID = "boundaries-fill";
